// extracted by mini-css-extract-plugin
module.exports = {"blurred":"SimpleVideoPlayer_blurred__a86Nr"};